<template>
    <Modal v-model:visible="visible">
        <template v-slot:header>
            <div>
                <h2 class="text-lg font-bold">Riepilogo Fees</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="grow-0 min-h-10 grid grid-cols-4 gap-2 py-4">

                <span class="font-bold">Nome</span>
                <span class="font-bold">Valore</span>
                <span class="font-bold text-right">Budget imponibile</span>
                <span class="font-bold text-right">Budget lordo IVA</span>

                <span class="col-span-4 border-b"></span>

                <template v-for="f in Fees">
                    <span class="">{{f.nome}}</span>
                    <span class="">{{f.valore}} %</span>
                    <span class=" text-right">{{(f.valore * f.budget / 100).toLocaleValueString(2, 2)}} €</span>
                    <span class=" text-right">{{(f.valore * f.budget * 0.0122).toLocaleValueString(2, 2)}} €</span>
                </template>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                            @click="$emit('update:visible', false)"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
        </template>
    </Modal>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import { mapGetters } from 'vuex';
import NextButton from "@/components/NextButton.vue";
import Modal from "@/components/Modal.vue";

@Options({
    name:'ModalFeesDetail',
    components: {Modal, NextButton},
    props: {
        visible: Boolean,
    },
    computed: {
        ...mapGetters('sprjDataManager', [
            'Fees',
        ]),
    },
})
export default class ModalFeesDetail extends Vue {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
